import APPRoutes from './app-routes/index';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
      <APPRoutes />
      <ToastContainer position="top-left" />
    </>
  );
}

export default App;
